module.exports = __webpack_public_path__ + "honor-certificate-03.jpg?ba4f97fab39fefdcc77ed2b5e77edd92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/honor-certificate-03.jpg
// module id = 153
// module chunks = 0